import { UserCreate } from '../../../domain/user/model/user-create';
import { UserUpdate } from '../../../domain/user/model/user-update';
import { UserPageCriteriaDto } from '../model/user-page-criteria-dto';

export namespace UserActions {
  const prefix = '[User]';

  export class GetPage {
    static readonly type = `${prefix} Get page`;

    constructor(readonly criteria: UserPageCriteriaDto) {}
  }

  export class RefreshPage {
    static readonly type = `${prefix} Refresh page`;

    constructor() {}
  }

  export class InvalidateCache {
    static readonly type = `${prefix} Invalidate cache`;

    constructor() {}
  }

  export class GetById {
    static readonly type = `${prefix} Get by id`;

    constructor(readonly id: string) {}
  }

  export class Create {
    static readonly type = `${prefix} Create`;

    constructor(readonly user: UserCreate) {}
  }

  export class Update {
    static readonly type = `${prefix} Update`;

    constructor(
      readonly id: string,
      readonly user: UserUpdate
    ) {}
  }

  export class Disable {
    static readonly type = `${prefix} Disable`;

    constructor(readonly id: string) {}
  }

  export class Enable {
    static readonly type = `${prefix} Enable`;

    constructor(readonly id: string) {}
  }

  export class ResendInvitation {
    static readonly type = `${prefix} Resend invitation`;

    constructor(readonly id: string) {}
  }
}
